import React, { useMemo } from "react";
import FileArrowDown from "../assets/icons/file-arrow-down.svg";

import { Document, Page, Text, View, StyleSheet, Image, PDFDownloadLink } from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
  page: {
    fontSize: 14,
    margin: 40,
  },
  roles: {
    marginBottom: 40,
  },
  section: {
    marginBottom: 40,
  },
  phase: {
    marginBottom: 10,
  },
  task: {
    display: "flex",
    flexDirection: "row",
  },
  image: {
    width: 15,
  },
});

export const DownloadPdf = ({ phases, tasks, tasksBundled, roles }) => {
  return useMemo(
    () => (
      <PDFDownloadLink key={Math.random()} document={<Print tasks={tasks} phases={phases} tasksBundled={tasksBundled} roles={roles} />} fileName="MySwift.pdf">
        {({ loading }) =>
          loading ? (
            "loading..."
          ) : (
            <div className="bg-primary-light w-full  py-4 font-bold text-primary-dark flex justify-center items-center">
              <FileArrowDown className="fill-current mr-2" width="16" />
              Export checklist
            </div>
          )
        }
      </PDFDownloadLink>
    ),
    [phases, roles, tasksBundled]
  );
};

// Create Document Component
const Print = ({ phases, tasks, tasksBundled, roles }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.roles}>
          <Text>Tasks for the following roles:</Text>
          {roles
            .filter((r) => r.checked)
            .map((r, i) => (
              <Text key={"r" + i}>- {r._}</Text>
            ))}
        </View>
        {phases?.map((p) => (
          <View key={p.id} style={styles.section}>
            <Text style={styles.phase}>
              {p.id + 1}. {p.title}
            </Text>

            {tasksBundled(p.id).map(
              (b) =>
                b.type === "active" &&
                b.tasks.map((t, i) => (
                  <View key={"t" + i} style={styles.task}>
                    {t.checked ? <Image style={styles.image} src="assets/img/checked.png" /> : <Image style={styles.image} src="assets/img/unchecked.png" />}
                    <Text key={t.id}>&nbsp;{t.title}</Text>
                  </View>
                ))
            )}

            {!tasksBundled(p.id).filter((t) => t.type === "active").length && (
              <View style={{ color: "#8b8b8b" }}>
                <Text>No tasks for selected roles in this phase</Text>
              </View>
            )}
          </View>
        ))}
      </Page>
    </Document>
  );
};

export default Print;
